import React, { useEffect, useState } from 'react';
import instance from '../api/axiosInstance';
import CorrectionModal from '../components/CorrectionModal';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress
} from '@mui/material';
import '../css/MesCvs.css';

const MesCvs = () => {
  const [cvs, setCvs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCV, setSelectedCV] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const userId = localStorage.getItem('userId');
  const userType = localStorage.getItem('userType'); // 'admin' ou 'user'

  const fetchCVs = async () => {
    try {
      let res;
      if (userType === 'admin') {
        res = await instance.get(`/cvs/admin`);
      } else {
        res = await instance.get(`/cvs/user/${userId}`);
      }
      setCvs(res.data.data || []);
    } catch (error) {
      console.error('Erreur lors du chargement des CVs :', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCVs();
  }, []);

  const handleOpenModal = (cv) => {
    setSelectedCV(cv);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCV(null);
  };

  const handleCVUpdated = () => {
    fetchCVs();
    handleCloseModal();
  };

  return (
    <Box className="mes-cvs-container">
      <Typography variant="h5" className="mes-cvs-title">
        📄 {userType === 'admin' ? 'Tous les CVs parsés' : 'Mes CVs analysés'}
      </Typography>

      {loading ? (
        <Box className="loading-box">
          <CircularProgress />
        </Box>
      ) : cvs.length === 0 ? (
        <Typography>Aucun CV analysé pour le moment.</Typography>
      ) : (
        <>
          <Typography variant="body1" className="cv-count">
            Total : <strong>{cvs.length}</strong> CV{cvs.length > 1 ? 's' : ''}
          </Typography>

          <TableContainer component={Paper} className="table-container">
            <Table>
              <TableHead>
                <TableRow>
                  {userType === 'admin' && <TableCell>Auteur</TableCell>}
                  <TableCell>Nom</TableCell>
                  <TableCell>Poste</TableCell>
                  <TableCell>Modèle</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cvs.map((cv) => (
                  <TableRow key={cv._id}>
                    {userType === 'admin' && (
                      <TableCell>
                        {cv.createdBy
                          ? `${cv.createdBy.firstName} ${cv.createdBy.lastName}`
                          : '—'}
                      </TableCell>
                    )}
                    <TableCell>{cv.name || 'Non défini'}</TableCell>
                    <TableCell>{cv.title || '-'}</TableCell>
                    <TableCell>{cv.model || 'option1'}</TableCell>
                    <TableCell>
                      {new Date(cv.createdAt).toLocaleString()}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleOpenModal(cv)}
                        className="action-btn"
                      >
                        Corriger
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

      {selectedCV && (
        <CorrectionModal
          open={modalOpen}
          handleClose={handleCloseModal}
          data={selectedCV}
          model={selectedCV.model}
          talentId={selectedCV.talentId || null}
          onCVGenerated={handleCVUpdated}
        />
      )}
    </Box>
  );
};

export default MesCvs;
